<template lang="pug">
.video-popup(v-if="videoId", @click.self="closeVideo")
  .video-popup__wrap
    .video-popup__video-wrapper
      .video-popup__video-height
        iframe.video-popup__video-iframe(:src="getVideoSrc" frameborder="0" allowfullscreen="allowfullscreen")
    button.video-popup__closer.controller-close(@click="closeVideo")
</template>
<script>
import MobileDetection from "@chronos/frontend-base/src/mixins/mobile_detection/MobileDetectionMixin";
export default {
  name: "VideoPopup",

  props: {
    videoType: {
      type: String,
      default: "youtube",
    },
    videoId: {
      type: String,
      default: null,
    },
  },

  mixin: [MobileDetection],

  computed: {
    getVideoSrc() {
      if(this.videoType === "vk")
        return this.getVkVideoSrc;
      else
        return this.getYoutubeVideoSrc;
    },
    getVkVideoSrc() {
      let code = this.videoId.split("_");
      return `https://vkvideo.ru/video_ext.php?oid=${code[0]}&id=${code[1]}&hash=${code[2]}&hd=2&autoplay=1`;
    },
    getYoutubeVideoSrc() {
      return `https://www.youtube.com/embed/${this.videoId}?autoplay=1&amp;rel=0&amp;showinfo=0`;
    },
  },

  mounted() {
    window.addEventListener("keydown", this.escHandler);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.escHandler);
  },

  methods: {
    closeVideo() {
      this.$emit("closeVideo");
    },
    escHandler(e) {
      const key = e.key;

      if (key === "Escape") {
        this.closeVideo();
      }
    },
  },
};
</script>

<style lang="scss">
@import "../style/video-popup.scss";
</style>
